var React = require('react');

function AngleDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M31.731 8.318c0.377 0.404 0.355 1.037-0.049 1.413l-12.953 12.090c-1.537 1.434-3.922 1.434-5.459 0l-12.953-12.090c-0.404-0.377-0.426-1.010-0.049-1.413s1.010-0.426 1.413-0.049l12.953 12.089c0.768 0.717 1.961 0.717 2.729 0l12.953-12.089c0.404-0.377 1.037-0.355 1.413 0.049z"}));
}

AngleDown.defaultProps = {"version":"1.1","viewBox":"0 0 32 32"};

module.exports = AngleDown;

AngleDown.default = AngleDown;
